import {
  LOAD_ORDER,
  LOAD_ORDERS,
  LOAD_ORDER_DETAILS,
  ORDERS_FAILED,
  ORDERS_LOADED,
  ORDER_DETAILS_FAILED,
  ORDER_DETAILS_LOADED,
  ORDER_FAILED,
  ORDER_LOADED,
  ORDER_SAVED,
  RESET_ORDERS,
  SAVE_ORDER,
  SAVE_ORDER_ERROR,
} from './actionTypes';
import type { IOrdersState } from './types';

export const initialState = {
  order: null,
  orderLoaded: false,
  orderLoading: false,
  orderError: null,

  orderStatusLoaded: false,
  orderStatusLoading: false,
  orderStatusError: null,

  orders: [],
  ordersLoaded: false,
  ordersLoading: false,
  ordersError: null,

  orderSaved: false,
  orderSaving: false,
  orderSaveError: null,
};

export const reducer = (
  state: IOrdersState = initialState,
  action: { type: any; payload?: any },
): IOrdersState => {
  switch (action.type) {
    case LOAD_ORDER:
      return { ...state, orderLoading: true, orderError: null };
    case ORDER_LOADED:
      return {
        ...state,
        order: action.payload,
        orderLoaded: true,
        orderLoading: false,
        orderError: null,
      };

    case ORDER_FAILED:
      return { ...state, orderError: action.payload, orderLoading: false, order: null };

    case LOAD_ORDERS:
      return { ...state, ordersLoading: true, ordersError: null };
    case ORDERS_LOADED:
      return {
        ...state,
        orders: action.payload,
        ordersLoaded: true,
        ordersLoading: false,
        ordersError: null,
      };
    case ORDERS_FAILED:
      return { ...state, ordersError: action.payload, ordersLoading: false, orders: [] };

    case LOAD_ORDER_DETAILS:
      return {
        ...state,
        orderStatusLoading: true,
        orderStatusError: null,
        orderStatusLoaded: false,
      };

    case ORDER_DETAILS_LOADED:
      return {
        ...state,
        orderStatusLoading: false,
        orderStatusError: null,
        orderStatusLoaded: true,
        orders: state.orders.map((order) => {
          if (order.internalOrderId === action.payload.internalOrderId) {
            return {
              ...order,
              ...action.payload,
            };
          }
          return order;
        }),
      };

    case ORDER_DETAILS_FAILED:
      return {
        ...state,
        orderStatusLoading: false,
        orderStatusError: action.payload,
        orderStatusLoaded: false,
      };

    case SAVE_ORDER:
      return { ...state, orderSaving: true, orderSaveError: null, orderSaved: false };

    case ORDER_SAVED:
      return { ...state, orderSaving: false, orderSaved: true };

    case SAVE_ORDER_ERROR:
      return { ...state, orderSaving: false, orderSaveError: action.payload };

    case RESET_ORDERS:
      return initialState;

    default:
      return state;
  }
};
